import { Box, Button, Card, CardActions, CardContent, CardMedia, Typography, useMediaQuery } from "@mui/material"
import { useAppDispatch } from "../../../Redux/store"
import { ProfileType } from "../../../Types/General"
import { setClientType, setProfileType, setProgress, setSubtitle } from "../Slices/accountCreationSlice"

interface ProfileSelectionProps {}
const cards = [
    {
        Id: ProfileType['Talent'],
        image: '/talentMedia.png',
        title: 'Talent account',
        subtitle: 'Job seeker',
        body: 'As a talent, you can apply for jobs that align with your skillset.',
        buttonText: 'I\'m a talent',
        disabled: false
    },
    {
        Id: ProfileType['Client'],
        image: '/clientMedia.png',
        title: 'Client account',
        subtitle: 'Talent seeker',
        body: 'As a client, you can hire individual contractors for the job.',
        buttonText: 'I\'m a client',
        disabled: false
    }
]
export const ProfileSelection = (props: ProfileSelectionProps) =>{
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const matches = useMediaQuery("(max-width: 715px)")
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    dispatch(setClientType(undefined))
    dispatch(setSubtitle('Select a profile type'))
    const handleSelection = (type: ProfileType) => {
        dispatch(setProfileType(type))
        const progress = type === ProfileType['Client']?60:75
        dispatch(setProgress(progress))
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Box display={"flex"} flexDirection={matches?"column":"row"} justifyContent={"center"} alignItems={"center"} gap={"30px"}>
                {
                    cards.map((card, idx) =>
                        <Card key={idx} sx={{width: "330px", borderRadius: "18px"}}>
                            <CardMedia
                                component={"img"}
                                height={"140"}
                                image={card.image}
                            />
                            <CardContent sx={{display: "flex", flexDirection: "column"}}>
                                <Typography variant="lora-title-large" marginBottom={1}>{card.title}</Typography>
                                <Typography variant="body-small" marginBottom={1} color={'black.200'}>{card.subtitle}</Typography>
                                <Typography variant="body-medium" color={'black.400'}>{card.body}</Typography>
                            </CardContent>
                            <CardActions sx={{paddingX: 0}}>
                                <Button variant="contained" disabled={card.disabled} sx={{marginLeft: "auto", marginBottom: 1, marginRight: "16px"}} onClick={() => handleSelection(card.Id)}>{card.buttonText}</Button>
                            </CardActions>
                        </Card>
                    )
                }
            </Box>
        </>
    )
}